import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=1449221b&"
import script from "./kanban.vue?vue&type=script&lang=js&"
export * from "./kanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports